import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teaching-staff',
  templateUrl: './teaching-staff.component.html',
  styleUrls: ['./teaching-staff.component.scss']
})
export class TeachingStaffComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
